import {
  kCoachTag,
  kKeypoint,
  kMissingGame,
  kMissingPoint,
  kRally,
  kRallyCounter,
  kRallyDrive,
  kRallyOutcomeIn,
  kRallyOutcomeNetted,
  kRallyOutcomeOut,
  kRallyOutcomeUnforcedError,
  kRallyTopspin,
  kReturnForcingError,
  kReturning,
  kReturnNetted,
  kReturnOut,
  kReturnUnforcedError,
  kReturnWinner,
  kServeAce,
  kServeCodeViolation,
  kServeFirst,
  kServeFootfault,
  kServeLet,
  kServeNet,
  kServeOther,
  kServeOut,
  kServeSecond,
  kServeTimeViolation,
  kServeWinner,
  kServing,
} from "./pstsDefines.js";

function convertSecondsFrom01011970ToDate(seconds) {
  return seconds * 1000;
}

function convertSecondsToDate(seconds) {
  // Apple CoreData reference date: seconds since Jan 1, 2001
  return (seconds + 978307200) * 1000;
}

function getNextLineData(str) {
  const line = str.replace(/[^\x20-\x7E]/g, ""); //escapeUnicode(str);
  const tokens = line.split("~");
  var label = tokens[0];
  var text = "";
  for (var nt = 1; nt < tokens.length; nt++) {
    if (text.length > 0) text += "~";
    text += tokens[nt];
  }
  try {
    if (text === "") {
      return { label: label, json: null };
    }
    const json = text === "(null)" ? null : JSON.parse(text);
    return { label: label, json: json };
  } catch (error) {
    console.log(error.message);
    return { label: label, json: null };
  }
}

export function importPSTS(buffer) {
  var match = null;
  var lineno = 0;
  const lines = buffer.split(/\r\n/);
  const line = lines[lineno];
  if (!n || n === 0) {
    if (line !== "PSTS") return null;
  }

  var json = getNextLineData(lines[++lineno]).json;

  match = {
    isDoubles: json.isDoubles ? json.isDoubles : false,
    isPractice: false,
    matchDate: json.matchDate === undefined ? 0 : Date.parse(json.matchDate),
    videoStartTime:
      json.videoStartTime === undefined ? 0 : Date.parse(json.videoStartTime),
    scoreModeAdvantage: json.scoreModeAdvantage ? json.scoreModeAdvantage : 0,
    scoreModeTiebreak: json.scoreModeTiebreak ? json.scoreModeTiebreak : 0,
    roundName: json.roundName ? json.roundName : "",
    temperature: json.temperature ? json.temperature : 0,
    videoFile: json.videoFile ? json.videoFile.replace("m3u8", "mp4") : "",
    importedFrom: json.importedFrom ? json.importedFrom : "",
    coder: json.coder ? json.coder : "",
    sets: [],
    videos: [],
  };

  json = getNextLineData(lines[++lineno]).json;
  match.tournament =
    json === null
      ? null
      : {
          name: json.name ? json.name : "",
          guid: json.guid ? json.guid : "",
          startDate: json.startDate ? convertSecondsToDate(json.startDate) : 0,
          enddate: json.endDate ? convertSecondsToDate(json.endDate) : 0,
          gender: json.gender ? json.gender : "",
          prizeMoney: json.prizeMoney ? json.prizeMoney : 0,
          code: json.code ? json.code : "",
          year: json.year ? json.year : 0,
        };

  json = getNextLineData(lines[++lineno]).json;
  if (match.tournament !== null) {
    match.tournament.country = getCountry(json);
  }

  json = getNextLineData(lines[++lineno]).json;
  match.court =
    json === null
      ? null
      : {
          surface: json.surface ? json.surface : "",
        };

  json = getNextLineData(lines[++lineno]).json;
  match.round =
    json === null
      ? null
      : {
          notes: json.notes ? json.notes : "",
          number: json.number ? json.number : 0,
        };

  json = getNextLineData(lines[++lineno]).json;
  match.weather =
    json === null
      ? null
      : {
          code: json.code ? json.code : "",
          notes: json.notes ? json.notes : "",
        };

  if (match.isDoubles) {
    json = getNextLineData(lines[++lineno]).json;
    match.teamA = getTeam(json);
    json = getNextLineData(lines[++lineno]).json;
    match.teamA.country = getCountry(json);
    json = getNextLineData(lines[++lineno]).json;
    match.teamA.player1 = getPlayer(json);
    json = getNextLineData(lines[++lineno]).json;
    match.teamA.player1.country = getCountry(json);
    json = getNextLineData(lines[++lineno]).json;
    match.teamA.player2 = getPlayer(json);
    json = getNextLineData(lines[++lineno]).json;
    match.teamA.player2.country = getCountry(json);

    json = getNextLineData(lines[++lineno]).json;
    match.teamB = getTeam(json);
    json = getNextLineData(lines[++lineno]).json;
    match.teamB.country = getCountry(json);
    json = getNextLineData(lines[++lineno]).json;
    match.teamB.player1 = getPlayer(json);
    json = getNextLineData(lines[++lineno]).json;
    match.teamB.player1.country = getCountry(json);
    json = getNextLineData(lines[++lineno]).json;
    match.teamB.player2 = getPlayer(json);
    json = getNextLineData(lines[++lineno]).json;
    match.teamB.player2.country = getCountry(json);
  } else {
    json = getNextLineData(lines[++lineno]).json;
    match.player1 = getPlayer(json);
    json = getNextLineData(lines[++lineno]).json;
    match.player1.country = getCountry(json);
    json = getNextLineData(lines[++lineno]).json;
    match.player2 = getPlayer(json);
    json = getNextLineData(lines[++lineno]).json;
    match.player2.country = getCountry(json);
  }

  var firste = null;
  var laste = null;
  var sm = null; // set
  var video = null;
  lineno++;
  for (var n = lineno; n < lines.length - 1; n++) {
    var nl = getNextLineData(lines[n]);
    json = nl.json;
    if (nl.label === "V") {
      video = getVideo(json);
      match.videos.push(video);
    } else if (nl.label === "S") {
      sm = getSet(json);
      match.sets.push(sm);
    } else if (nl.label === "E0") {
      var e = getEvent(json, sm, match, n);
      if (match.isDoubles) {
        e.player = match.teamA.player1;
        e.playerGuid = match.teamA.player1.guid;
        e.team = match.teamA;
      } else {
        e.player = match.player1;
        e.playerGuid = match.player1.guid;
      }
      if (laste && e.timestamp < laste.timestamp) {
        e.timestamp = laste.timestamp + 2;
      }
      e.playerNo = 0;
      if (firste === null) firste = e;
      laste = e;
      sm.events.push(e);
    } else if (nl.label === "E1") {
      var e = getEvent(json, sm, match, n);
      if (match.isDoubles) {
        e.player = match.teamA.player2;
        e.playerGuid = match.teamA.player2.guid;
        e.team = match.teamA;
      } else {
        e.player = match.player2;
        e.playerGuid = match.player2.guid;
      }
      if (laste && e.timestamp < laste.timestamp) {
        e.timestamp = laste.timestamp + 2;
      }
      e.playerNo = 1;
      if (firste === null) firste = e;
      laste = e;
      sm.events.push(e);
    } else if (nl.label === "E2") {
      var e = getEvent(json, sm, match, n);
      if (match.isDoubles) {
        e.player = match.teamB.player1;
        e.playerGuid = match.teamB.player1.guid;
        e.team = match.teamB;
      }
      if (laste && e.timestamp < laste.timestamp) {
        e.timestamp = laste.timestamp + 2;
      }
      e.playerNo = 2;
      if (firste === null) firste = e;
      laste = e;
      sm.events.push(e);
    } else if (nl.label === "E3") {
      var e = getEvent(json, sm, match, n);
      if (match.isDoubles) {
        e.player = match.teamB.player2;
        e.playerGuid = match.teamB.player2.guid;
        e.team = match.teamB;
      }
      e.playerNo = 3;
      if (laste && e.timestamp < laste.timestamp) {
        e.timestamp = laste.timestamp + 2;
      }
      if (firste === null) firste = e;
      laste = e;
      sm.events.push(e);
    }
  }
  if (match.isDoubles) {
  } else {
    match.player1CountryCode =
      match.player1.country === null ? "UNK" : match.player1.country.code;
    match.player1FirstName =
      match.player1.firstName === undefined ? "" : match.player1.firstName;
    match.player1LastName =
      match.player1.lastName === undefined ? "" : match.player1.lastName;
    match.player2CountryCode =
      match.player2.country === null ? "UNK" : match.player2.country.code;
    match.player2FirstName =
      match.player2.firstName === undefined ? "" : match.player2.firstName;
    match.player2LastName =
      match.player2.lastName === undefined ? "" : match.player2.lastName;
    match.player1Guid = match.player1.guid;
    match.player2Guid = match.player2.guid;
  }
  for (var sm of match.sets) {
    for (var e of sm.events) {
      // `videoOffset` is only derived for matches that carry a video start time
      // (imported matches). Locally-coded matches store the event's video
      // position directly in `timestamp`, so fall back to a zero offset instead
      // of producing NaN (timestamp - undefined).
      const videoOffset = match.videoOffset ?? 0;
      e.videoTime = e.timestamp - videoOffset;
      e.playerCountryCode =
        e.player.country === null ? "UNK" : e.player.country.code;
    }
  }
  if (match.isDoubles) {
    var teamAGuid = match.teamA.guid ? match.teamA.guid : match.teamA.player1.guid + "_" + match.teamA.player2.guid;
    var teamBGuid = match.teamB.guid ? match.teamB.guid : match.teamB.player1.guid + "_" + match.teamB.player2.guid;
    match.guid = 
      teamAGuid +
      "_" +
      teamBGuid +
      "_" +
      match.matchDate.toString();
  } else {
    match.guid =
      match.player1.guid +
      "_" +
      match.player2.guid +
      "_" +
      match.matchDate.toString();
  }
  return match;
}

function getPlayer(json) {
  var pl =
    json === null
      ? null
      : {
          firstName: json.firstName ? json.firstName : "",
          lastName: json.lastName ? json.lastName : "",
          userDefined01: json.userDefined01 ? json.userDefined01 : "",
          userDefined02: json.userDefined02 ? json.userDefined02 : "",
          dob: json.dob ? convertSecondsFrom01011970ToDate(json.dob) : 0,
          hand: json.hand ? json.hand : 0,
          weight: json.weight ? json.weight : 0,
          notes: json.notes ? json.notes : "",
          height: json.height ? json.height : 0,
          guid: json.guid ? json.guid : "",
          email: json.email ? json.email : "",
          gender: json.gender ? json.gender : "",
        };
  return pl;
}

function getCountry(json) {
  var c =
    json === null
      ? null
      : {
          name: json.name ? json.name : "",
          code: json.code ? json.code : "",
        };
  return c;
}

function getTeam(json) {
  var t =
    json === null
      ? null
      : {
          name: json.name ? json.name : "",
          code: json.code ? json.code : "",
          notes: json.notes ? json.notes : "",
          userDefined01: json.userDefined01 ? json.userDefined01 : "",
          userDefined02: json.userDefined02 ? json.userDefined02 : "",
        };
  return t;
}

function getSet(json) {
  var s =
    json === null
      ? null
      : {
          number: json.number ? json.number : 0,
          currentSkill: json.currentSkill ? json.currentSkill : 0,
          isTiebreak: json.isTiebreak ? json.isTiebreak : false,
          oppositionGameScore: json.oppositionGameScore
            ? json.oppositionGameScore
            : 0,
          oppositionScore: json.oppositionScore ? json.oppositionScore : 0,
          playerGameScore: json.playerGameScore ? json.playerGameScore : 0,
          playerScore: json.playerScore ? json.playerScore : 0,
          serves: json.serves ? json.serves : 0,
          servingZone: json.servingZone ? json.servingZone : 0,
          onTopCourt: json.onTopCourt ? json.onTopCourt : false,
          user1: json.user1 ? json.user1 : "",
          user2: json.user2 ? json.user2 : "",
          events: [],
        };
  return s;
}

function getVideo(json) {
  var video =
    json === null
      ? null
      : {
          startTime: convertSecondsFrom01011970ToDate(json.startTime),
          name: json.name ? json.name : "",
          videoOrder: json.videoOrder ? json.videoOrder : 0,
          url: json.url ? json.url : "",
        };
  return video;
}

// Doubles-only: "serveFormation,returnFormation,netPosition" (legacy files
// use "|" as the delimiter instead of ",") — same index order/int parsing
// as the iOS app's EventEntity+sup.m serveFormation/returnFormation/
// netPosition accessors, defaulting each to 0 if absent.
export function parsePlayerPositions(playerPositions) {
  const tokens = (playerPositions || "").split(
    playerPositions?.includes("|") ? "|" : ",",
  );
  return {
    serveFormation: parseInt(tokens[0], 10) || 0,
    returnFormation: parseInt(tokens[1], 10) || 0,
    netPosition: parseInt(tokens[2], 10) || 0,
  };
}

function getEvent(json, sm, match, lineno) {
  if (match.videoOffset === undefined && match.videoStartTime > 0) {
    const tt = new Date(json.timestamp);
    var vo = (json.timestamp - match.videoStartTime / 1000) % 3600;
    if (vo < 0) {
      vo += 3600;
    }
    match.videoOffset = json.timestamp - vo;
  }
  var rs = json.rallyWinner ? json.rallyWinner : 0;
  var e =
    json === null
      ? null
      : {
          timestamp: json.timestamp ? json.timestamp : 0,
          atNet: json.atNet ? json.atNet : false,
          breakPoints: json.breakPoints ? json.breakPoints : 0,
          direction: json.direction ? json.direction : 0,
          endBall: json.endBall ? json.endBall : 0,
          hand: json.hand ? json.hand : 0,
          isServing: json.isServing ? json.isServing : false,
          midBall: json.midBall ? json.midBall : 0,
          outcome: json.outcome ? json.outcome : 0,
          reach: json.reach ? json.reach : 0,
          result: json.result ? json.result : 0,
          scores: json.scores ? json.scores : "",
          selected: json.selected ? json.selected : false,
          skill: json.skill ? json.skill : 0,
          startBall: json.startBall ? json.startBall : 0,
          subskill1: json.subskill1 ? json.subskill1 : 0,
          subskill2: json.subskill2 ? json.subskill2 : 0,
          user1: json.user1 ? json.user1 : "",
          user2: json.user2 ? json.user2 : "",
          videoDuration: json.videoDuration ? json.videoDuration : 0,
          playerPositions: json.playerPositions ? json.playerPositions : "",
          ...parsePlayerPositions(json.playerPositions),
          ballMetrics: json.ballMetrics ? json.ballMetrics : "",
          ballToss: json.ballToss ? json.ballToss : "",
          ballHit: json.ballHit ? json.ballHit : "",
          ballBounce: json.ballBounce ? json.ballBounce : "",
          rallyOrder: json.rallyOrder ? json.rallyOrder : 0,
          rallyWinner: rs,
          user3: json.user3 ? json.user3 : "",
          user4: json.user4 ? json.user4 : "",
          eventId: json.eventId ? json.eventId : lineno,
          selected: false ? json.selected : false,
          setNumber: sm.number ? sm.number : 0,
          videoFile: match.videoFile ? match.videoFile : "",
        };
  if (!e) {
    console.log("no event");
  } else {
    if (e.outcome === kReturnOut || e.outcome === kReturnNetted) {
      e.outcome = kReturnUnforcedError;
    } else if (
      e.outcome === kRallyOutcomeOut ||
      e.outcome === kRallyOutcomeNetted
    ) {
      e.outcome = kRallyOutcomeUnforcedError;
    }
    e.eventString = eventString(e);
    e.realScores = realScores(e, sm, match);
  }

  return e;
}

export function eventString(e) {
  var s = "";
  const skill = e.skill;
  var subskill1 = e.subskill1;
  var subskill2 = e.subskill2;
  var outcome = e.outcome;
  var hand = e.hand;
  if (hand > 1) {
    hand = 1;
  }
  if (outcome < 0) {
    outcome = 0;
  }

  if (skill === kCoachTag) {
    return e.user1;
  } else if (skill === kServing) {
    var ss = subskill1 === kServeFirst ? "1st Serve" : "2nd Serve";
    if (outcome === kServeFootfault) {
      if (subskill1 === kServeSecond) {
        return ss + " - Double fault";
      } else {
        return ss + " - Footfault";
      }
    } else if (outcome === kServeLet) {
      return ss + " - Let";
    } else if (outcome === kServeOut) {
      if (subskill1 === kServeSecond) {
        return ss + " - Double fault";
      } else {
        return ss + " - Out";
      }
    } else if (outcome === kServeNet) {
      if (subskill1 === kServeSecond) {
        return ss + " - Double fault";
      } else {
        return ss + " - Net";
      }
    } else if (outcome === kServeAce) {
      return ss + " - Ace";
    } else if (outcome === kServeWinner) {
      return ss + " - Winner";
    } else if (outcome === kServeTimeViolation) {
      return ss + " - Time Violation";
    } else if (outcome === kServeCodeViolation) {
      return ss + " - Code Violation";
    } else if (outcome === kServeOther) {
      return ss + " - Other Violation";
    } else {
      return ss;
    }
  } else if (skill === kReturning) {
    const outcomeMenu = [
      "In",
      "Off Net",
      "Volleyed",
      "Winner",
      "Forced Error",
      "Passing Shot",
      "Out",
      "Unforced Error",
      "First",
      "Second",
      "Netted",
    ];
    const handMenu = ["Forehand", "Backhand"];
    const rallyMenu = [
      "Drive",
      "Slice",
      "Topspin",
      "Volley",
      "Overhead",
      "Lob",
      "Drop",
      "Other",
      "Drive Volley",
      "Serve Volley",
      "Smash",
      "Approach",
      "Drop Volley",
      "Bounce Overhead",
      "Poach Volley",
      "Half Volley",
      "Attempted Passing Shot",
      "Power",
      "Flat",
      "Kick",
      "",
    ];

    if (subskill2 === -1) {
      subskill2 = rallyMenu.length - 1;
    }

    if (
      outcome === kReturnOut ||
      outcome === kReturnForcingError ||
      outcome === kReturnUnforcedError ||
      outcome === kReturnWinner
    ) {
      s =
        "Return " +
        handMenu[hand] +
        " - " +
        rallyMenu[subskill2] +
        " - " +
        outcomeMenu[outcome];
      return s;
    } else {
      s = "Return " + handMenu[hand] + " - " + rallyMenu[subskill2];
      return s;
    }
  } else if (skill === kRally || skill === kKeypoint) {
    const handMenu = ["Forehand", "Backhand"];
    const rallyMenu = [
      "Drive",
      "Slice",
      "Topspin",
      "Volley",
      "Overhead",
      "Lob",
      "Drop",
      "Other",
      "Drive Volley",
      "Serve Volley",
      "Smash",
      "Approach",
      "Drop Volley",
      "Bounce Overhead",
      "Poach Volley",
      "Half Volley",
      "Attempted Passing Shot",
      "Power",
      "Flat",
      "Kick",
      "",
    ];
    const outcomeMenu = [
      "In",
      "Out",
      "Winner",
      "Unforced Error",
      "Forced Error",
      "Passing Shot Winner",
      "Netcord",
      "Put Away",
      "Netted",
      "OutOffNet",
      "NettedPassingShot",
      "Out Passing Shot",
      "Cancel",
    ];

    if (subskill2 === -1) {
      subskill2 = rallyMenu.length - 1;
    } else if (subskill2 === kRallyDrive) {
      subskill2 = kRallyTopspin;
    }

    if (outcome === kRallyOutcomeIn) {
      s = handMenu[hand] + " - " + rallyMenu[subskill2];
      return s;
    } else {
      s =
        handMenu[hand] +
        " - " +
        rallyMenu[subskill2] +
        " - " +
        outcomeMenu[outcome];
      return s;
    }
  } else if (skill === kRallyCounter) {
    s = "Rally shot";
  } else if (skill === kMissingPoint) {
    s = "Missing Point...";
  } else if (skill === kMissingGame) {
    s = "Missing Game...";
  }
  return s;
}

export function realScores(e, sm, match) {
  var a = e.scores.split(" ");
  if (a.length === 2) {
    var a1 = a[0].split(":");
    if (a1.length === 2) {
      e.playerSetScore = Number.parseInt(a1[0]);
      e.oppositionSetScore = Number.parseInt(a1[1]);
    }
    var a2 = a[1].split(":");
    if (a2.length === 2) {
      const ps = a2[0];
      const os = a2[1];
      e.playerGameScore = Number.parseInt(ps);
      e.oppositionGameScore = Number.parseInt(os);
      if (
        sm.isTiebreak &&
        e.playerSetScore === 6 &&
        e.oppositionSetScore === 6
      ) {
        return e.scores;
      } else if (
        match &&
        // match.isDoubles &&
        sm.number === 3 &&
        match.scoreModeTiebreak > 0
      ) {
        return e.playerGameScore + "-" + e.oppositionGameScore;
      } else {
        var ss = ["00", "15", "30", "40"];
        var pss = "40";
        if (ps >= 0 && ps < 4) {
          pss = ss[ps];
        } else if (ps >= 4 && ps > os) {
          pss = "A";
        }
        var oss = "40";
        if (os >= 0 && os < 4) {
          oss = ss[os];
        } else if (os >= 4 && os > ps) {
          oss = "A";
        }
        return ("%@ %@:%@", a[0] + " " + pss + ":" + oss);
      }
    }
  }
  return "";
}

// Convert a single locally-coded event (scores as an object, ball positions as
// {x, y}, video position in `videoTime`/`timestampseconds`) into the PSTS/DB
// event shape the reports and Video Analysis expect. Unlike a writeToPSTS →
// importPSTS round-trip, this preserves the event's real timestamp/videoTime
// (importPSTS bumps out-of-order timestamps, corrupting reversed event lists).
export function codingEventToDBEvent(ev, sm, match) {
  if (!ev || typeof ev.scores === "string") return ev; // already DB format

  const pg = ev.player?.guid;
  const nameKey = (p) =>
    `${(p?.firstName ?? "").trim()}|${(p?.lastName ?? "").trim()}`;
  let playerNo = 0;
  let player = match?.player1 ?? null;
  let team;
  if (match?.isDoubles) {
    // Doubles attributes every shot to an INDIVIDUAL, tracked separately from
    // `ev.player` (which is always the TEAM-level object, see CodingPage.jsx's
    // finaliseCreateEvent) — comparing `pg` (a team guid) against individual
    // player guids here would never match, silently defaulting every event
    // to playerNo 0 (StatsObject.js/TennisCourt.jsx both expect `e.player`/
    // `e.playerGuid` to be the individual, e.g. `e.player.guid ===
    // team.player1.guid`).
    const ig = ev.individualPlayer?.guid ?? ev.individualPlayerGuid;
    if (ig === match.teamA?.player1?.guid) { playerNo = 0; player = match.teamA.player1; team = match.teamA; }
    else if (ig === match.teamA?.player2?.guid) { playerNo = 1; player = match.teamA.player2; team = match.teamA; }
    else if (ig === match.teamB?.player1?.guid) { playerNo = 2; player = match.teamB.player1; team = match.teamB; }
    else if (ig === match.teamB?.player2?.guid) { playerNo = 3; player = match.teamB.player2; team = match.teamB; }
    else if (pg === match.teamA?.guid) { playerNo = 0; player = match.teamA.player1; team = match.teamA; }
    else if (pg === match.teamB?.guid) { playerNo = 2; player = match.teamB.player1; team = match.teamB; }
  } else {
    // Singles. Attribute robustly: an explicit event `playerNo` wins; otherwise
    // match on distinct GUIDs; otherwise (GUIDs missing/identical, or orphaned
    // after a player merge repointed the match but not its events) fall back to
    // the player's name.
    const g1 = match?.player1?.guid;
    const g2 = match?.player2?.guid;
    const distinctGuids = g1 && g2 && g1 !== g2;
    const guidMatches = distinctGuids && (pg === g1 || pg === g2);
    if (typeof ev.playerNo === "number") {
      playerNo = ev.playerNo === 1 ? 1 : 0;
    } else if (guidMatches) {
      playerNo = pg === g2 ? 1 : 0;
    } else if (
      nameKey(ev.player) === nameKey(match?.player2) &&
      nameKey(match?.player1) !== nameKey(match?.player2)
    ) {
      playerNo = 1;
    }
    player = playerNo === 1 ? match?.player2 ?? null : match?.player1 ?? null;
  }

  const sc = ev.scores ?? {};
  const scoresStr = `${sc.player1SetScore ?? 0}:${sc.player2SetScore ?? 0} ${sc.player1GameScore ?? 0}:${sc.player2GameScore ?? 0}`;
  const videoPos = ev.videoTime ?? ev.timestampseconds ?? 0;

  const e = {
    timestamp: ev.timestampseconds ?? 0,
    atNet: false,
    startBall: ev.start ? `${ev.start.x},${ev.start.y * 2}` : "0,0",
    endBall: ev.end ? `${ev.end.x},${ev.end.y * 2}` : "0,0",
    midBall: "0,0",
    hand: ev.hand ?? 0,
    outcome: ev.outcome ?? 0,
    reach: ev.reach ?? 0,
    result: ev.result ?? 0,
    scores: scoresStr,
    skill: ev.skill ?? 0,
    subskill1: ev.subskill1 ?? 0,
    subskill2: ev.subskill2 ?? 0,
    videoDuration: videoPos,
    videoTime: videoPos,
    setNumber: sm?.number ?? sm?.setNumber ?? 0,
    selected: false,
    player,
    playerGuid: match?.isDoubles ? (player?.guid ?? pg) : (pg ?? player?.guid),
    playerNo,
    videoFile: match?.videoFile ?? "",
  };
  if (team) e.team = team;
  if (match?.isDoubles) {
    e.individualPlayer = player;
    e.individualPlayerGuid = player?.guid;
    e.serveFormation = ev.serveFormation ?? 0;
    e.returnFormation = ev.returnFormation ?? 0;
    e.netPosition = ev.netPosition ?? 0;
    e.playerPositions = `${e.serveFormation},${e.returnFormation},${e.netPosition}`;
  }
  e.playerCountryCode = player?.country == null ? "UNK" : player.country.code;
  e.eventString = eventString(e);
  e.realScores = realScores(e, sm, match);
  return e;
}

// Convert all locally-coded sets of a match into PSTS/DB-format sets, with
// events sorted into chronological (ascending) order.
export function normaliseCodingSets(match) {
  return (match?.sets ?? []).map((s) => {
    const sm = {
      ...s,
      number: s.number ?? s.setNumber ?? 0,
      setNumber: s.setNumber ?? s.number ?? 0,
      isTiebreak: s.isTiebreak ?? false,
      playerScore: s.scores?.player1SetScore ?? s.playerScore ?? 0,
      oppositionScore: s.scores?.player2SetScore ?? s.oppositionScore ?? 0,
    };
    let eventId = 0;
    const events = (s.events ?? [])
      .map((ev) => codingEventToDBEvent(ev, sm, match))
      .sort((a, b) => (a.timestamp ?? 0) - (b.timestamp ?? 0))
      .map((e) => ({ ...e, eventId: eventId++ }));
    return { ...sm, events };
  });
}

export function writeToPSTS(m) {
  var s = "PSTS\r\n";
  let dt = new Date();
  if (m.matchDate) {
    dt = new Date(m.matchDate);
  } else if (m.date) {
    dt = new Date(m.date.seconds * 1000);
  }
  const xm = {
    playerGuid: m.player1.guid,
    oppositionGuid: m.player2.guid,
    playingConditionsGuid: "",
    roundName: m.round,
    tournamentGuid: m.tournament?.guid,
    weatherGuid: "",
    numberOfSets: m.sets ? m.sets.length : 0,
    coderName: m.username,
    teamAGuid: "",
    teamBGuid: "",
    guid: m.guid,
    matchDate: dt.toISOString(),
    temperature: 0,
    scoreModeAdvantage: m.scoreModeAdvantage ? m.scoreModeAdvantage : 0,
    scoreModeTiebreak: m.scoreModeTiebreak ? m.scoreModeTiebreak : 0,
    videoFile: m.videoFile ? m.videoFile : "",
    videoStartTime: m.videoStartTime
      ? new Date(m.videoStartTime).toISOString()
      : "",
    isDoubles: m.isDoubles ? m.isDoubles : false,
  };
  s += "M~" + JSON.stringify(xm) + "\r\n";
  const xt = {
    name: m.tournament?.name ? m.tournament?.name : "",
    guid: m.tournament?.guid ? m.tournament?.guid : "",
    gender: m.player1.gender === 0 ? "F" : "M",
    year: m.tournament?.startDate
      ? new Date(m.tournament.startDate.seconds * 1000).getFullYear()
      : "",
  };
  s += "T~" + JSON.stringify(xt) + "\r\n";
  s += `C~{code:${
    m.tournament?.country ? m.tournament?.country : ""
  }, name:''}\r\n`;
  const xsur = {
    surface: m.tournament?.surface ? m.tournament?.surface : "",
  };
  s += `SF~${JSON.stringify(xt)}\r\n`;
  const xr = {
    notes: m.round ? m.round : "",
    number: 0,
  };
  s += `R~${JSON.stringify(xr)}\r\n`;
  s += "W~(null)\r\n";
  if (m.isDoubles) {
    // Doubles matches store players under teamA/teamB (see AllFiltersPanel.jsx,
    // CodingPage.jsx, etc.) — there's no player3/player4/team1/team2 on `m`.
    const teamA = m.teamA ?? {};
    const teamB = m.teamB ?? {};
    const xTeamPlayer = (p) => ({
      firstName: p?.firstName ? p.firstName : "",
      lastName: p?.lastName ? p.lastName : "",
      shortName:
        p?.firstName && p?.lastName
          ? `${p.firstName.substring(0, 1)}. ${p.lastName}`
          : "",
      guid: p?.guid ? p.guid : "",
      country: { code: p?.country?.code ? p.country.code : "", name: "" },
    });
    const xTeamCountry = (p) => ({
      code: p?.country?.code ? p.country.code : "",
      name: "",
    });
    s += "TM~" + JSON.stringify({ guid: teamA.guid ?? "", name: teamA.name ?? "" }) + "\r\n";
    s += "P~" + JSON.stringify(xTeamPlayer(teamA.player1)) + "\r\n";
    s += "C~" + JSON.stringify(xTeamCountry(teamA.player1)) + "\r\n";
    s += "P~" + JSON.stringify(xTeamPlayer(teamA.player2)) + "\r\n";
    s += "C~" + JSON.stringify(xTeamCountry(teamA.player2)) + "\r\n";

    s += "TM~" + JSON.stringify({ guid: teamB.guid ?? "", name: teamB.name ?? "" }) + "\r\n";
    s += "P~" + JSON.stringify(xTeamPlayer(teamB.player1)) + "\r\n";
    s += "C~" + JSON.stringify(xTeamCountry(teamB.player1)) + "\r\n";
    s += "P~" + JSON.stringify(xTeamPlayer(teamB.player2)) + "\r\n";
    s += "C~" + JSON.stringify(xTeamCountry(teamB.player2)) + "\r\n";
  } else {
    const xp1 = {
      firstName: m.player1.firstName ? m.player1.firstName : "",
      lastName: m.player1.lastName ? m.player1.lastName : "",
      shortName:
        m.player1.firstName && m.player1.lastName
          ? `${m.player1.firstName.substring(0, 1)}. ${m.player1.lastName}`
          : "",
      guid: m.player1.guid ? m.player1.guid : "",
      country: { code: m.player1.country ? m.player1.country : "", name: "" },
    };
    s += "P~" + JSON.stringify(xp1) + "\r\n";
    const xpc1 = {
      code: m.player1.country ? m.player1.country : "",
      name: "",
    };
    s += "C~" + JSON.stringify(xp1) + "\r\n";
    const xp2 = {
      firstName: m.player2.firstName ? m.player2.firstName : "",
      lastName: m.player2.lastName ? m.player2.lastName : "",
      shortName:
        m.player2.firstName && m.player2.lastName
          ? `${m.player2.firstName.substring(0, 1)}. ${m.player2.lastName}`
          : "",
      guid: m.player2.guid ? m.player2.guid : "",
      country: { code: m.player2.country ? m.player2.country : "", name: "" },
    };
    s += "P~" + JSON.stringify(xp2) + "\r\n";
    const xpc2 = {
      code: m.player2.country ? m.player2.country : "",
      name: "",
    };
    s += "C~" + JSON.stringify(xpc2) + "\r\n";
  }
  for (var n = 0; n < m.sets?.length; n++) {
    let se = m.sets[n];
    const sc = se.scores ?? {};
    const xs = {
      number: se.setNumber,
      matchGuid: m.guid,
      playerScore: sc.player1SetScore ?? 0,
      oppositionScore: sc.player2SetScore ?? 0,
      playerGameScore: sc.player1GameScore ?? 0,
      oppositionGameScore: sc.player2GameScore ?? 0,
      isTiebreak: se.isTiebreak ? se.isTiebreak : false,
    };
    s += "S~" + JSON.stringify(xs) + "\r\n";
    let events = se.events;
    for (var ev of events) {
      let pn = ev.player === m.player1 ? 0 : 1;
      if (m.isDoubles) {
        // ev.player is always the TEAM-level object (see CodingPage.jsx's
        // finaliseCreateEvent) — the actual hitter is tracked separately via
        // individualPlayer/individualPlayerGuid, set once a serve/return/
        // rally resolves an individual.
        const ig = ev.individualPlayer?.guid ?? ev.individualPlayerGuid;
        if (ig === m.teamA?.player1?.guid) pn = 0;
        else if (ig === m.teamA?.player2?.guid) pn = 1;
        else if (ig === m.teamB?.player1?.guid) pn = 2;
        else if (ig === m.teamB?.player2?.guid) pn = 3;
        else pn = ev.player?.guid === m.teamB?.guid ? 2 : 0;
      }
      const xe =
        ev.atNet !== undefined
          ? ev
          : {
              atNet: false,
              eventString: eventString(ev),
              setNumber: se.setNumber,
              skill: ev.skill,
              subskill1: ev.subskill1,
              subskill2: ev.subskill2,
              outcome: ev.outcome,
              result: ev.result,
              hand: ev.hand,
              scores: `${ev.scores?.player1SetScore ?? 0}:${ev.scores?.player2SetScore ?? 0} ${ev.scores?.player1GameScore ?? 0}:${ev.scores?.player2GameScore ?? 0}`, //"0:0 0:0"
              startBall: `${ev.start.x},${ev.start.y}`, //"41.544692015503244,2.2482852080893796"
              midBall: "0,0",
              endBall: `${ev.end.x},${ev.end.y}`,
              timeStamp: new Date(ev.timestampseconds * 1000).toISOString(), //"2024-07-18T13:51:53.084Z"
              timestamp: ev.timestampseconds,
              ballMetrics: "", //"196.064,-2266.23,-1.744,0.657,0.526"
              eventId: 0,
              user4: "", //"MS015_01_01_01_01"
              user2: "", //"0001_0000"
              playerNo: pn,
              ...(m.isDoubles && {
                playerPositions: `${ev.serveFormation ?? 0},${ev.returnFormation ?? 0},${ev.netPosition ?? 0}`,
              }),
            };
      let sev = "E" + pn + "~" + JSON.stringify(xe) + "\r\n";
      sev = sev.replace("null", '""');
      s += sev;
    }
  }
  return s;
  // const str = wholeMatchDataString(m);
  // // await storeWholeMatch(str);
  // // saveToPC(m.matchDescription + ".dat", str);
  // // saveToPC(m.matchDescription + ".psts", s);
  // const st = {
  //   matchId: null,
  //   pstsFileData: s,
  //   locVideoFilePath: null,
  //   locVideoStartTime: 0,
  // };
  // navigate("/match", { state: st });
}
